'use client';

import type { ReactNode } from 'react';

type SettingsFieldErrorProps = {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
};

/**
 * Validation message under a settings row's control.
 *
 * Lives in the kit rather than at the call site because Tailwind's source scan
 * is pinned to `src/components/DS/**` — a `text-text-danger` written in a view
 * file is never generated (see the note in ./index.ts).
 */
export const SettingsFieldError = ({
  children,
  className,
  'data-testid': dataTestId,
}: SettingsFieldErrorProps) => (
  <p
    data-lula-ds=""
    data-testid={dataTestId}
    className={`typography-body-sm m-0 pt-space-4 text-text-danger${
      className ? ` ${className}` : ''
    }`}
  >
    {children}
  </p>
);

export default SettingsFieldError;
